import { newOrganizationInvitation } from '@neptune/invitations-domain';

export const MEMBERS_LIMIT_REACHED_MODAL = 'MEMBERS_LIMIT_REACHED_MODAL';
export const ALREADY_INVITED_MODAL_TYPE = 'ALREADY_INVITED_MODAL_TYPE';
export const ALREADY_AN_ADMIN_MODAL = 'ALREADY_AN_ADMIN_MODAL';
export const ONLY_ADMIN_MODAL = 'ONLY_ADMIN_MODAL';
export const DELETE_MODAL_TYPE = 'USER_REMOVE_MODAL';
export const CANCEL_SUBSCRIPTION_ERROR_MODAL = 'CANCEL_SUBSCRIPTION_ERROR_MODAL';
export const ADD_OUTSIDER_TO_WORKSPACE_AND_PROJECT_MODAL =
  'ADD_OUTSIDER_TO_WORKSPACE_AND_PROJECT_MODAL';

export type AddOutsiderToWorkspaceAndProjectModalData = {
  invitee: string;
  newOrganizationInvitation: Parameters<typeof newOrganizationInvitation>[0];
};
